import { Point } from 'pixi.js'
import spritePool from '../spritePool'
import { walrusBody } from './p2'
import { getLatestState } from '../gameState'

let orientation = 1
let frameCounter = 1
let deltaCounter = 0
let historicPositions = [] as number[]
const lastPosition = new Point(0, 0)
const minVelocityToChangeDirection = 4
const maxCharge = 60
const chargeFrames = [4, 5, 6, 7, 8, 9]
const maxChargeFrames = [10, 11, 12]
const maxDistance = 50

export default () => {
	const { player } = getLatestState()

	if (spritePool.walrusHead === null) return

	if (walrusBody.velocity[0] < -minVelocityToChangeDirection) orientation = -1
	if (walrusBody.velocity[0] > minVelocityToChangeDirection) orientation = 1

	if (walrusBody.velocity[0] < minVelocityToChangeDirection && walrusBody.velocity[0] > -minVelocityToChangeDirection) {
		orientation = player.direction
	}

	const walrusBodyPosition = new Point(walrusBody.position[0], walrusBody.position[1])
	spritePool.walrusMainBody.position.copyFrom(walrusBodyPosition)
	spritePool.walrusHead.x = lastPosition.x + 50 * orientation
	spritePool.walrusHead.y = lastPosition.y - 30
	lastPosition.copyFrom(walrusBodyPosition)

	historicPositions.push(walrusBody.position[0], walrusBody.position[1])
	if (historicPositions.length > 42) {
		historicPositions = historicPositions.slice(2)
	}

	spritePool.walrusMainBody.scale.x = orientation
	spritePool.walrusHead.scale.x = orientation



	if (player.jumpCharge > 20) {
		if (player.jumpCharge > maxCharge - maxChargeFrames.length) {
			const index = frameCounter % maxChargeFrames.length
			spritePool.walrusHead.gotoAndStop(maxChargeFrames[index])
			deltaCounter === 12 ? (deltaCounter = 0) : deltaCounter++
			if (deltaCounter === 0) frameCounter++
		} else {
			spritePool.walrusHead.gotoAndStop(chargeFrames[Math.floor((player.jumpCharge / maxCharge) * chargeFrames.length) - 1])
		}
		// Big eyes if the walrus is falling
	} else if (walrusBody.velocity[1] > 50) {
		spritePool.walrusHead.gotoAndStop(2)
		// Normal eyes if the walrus is not charging
	} else {
		spritePool.walrusHead.gotoAndStop(1)
	}

	if (historicPositions.length < 30) return

	const walrusMidBodyPosition = new Point(historicPositions[24] - 30, historicPositions[25])

	// check if the walrusMidBody is too far away from main body and move it closer if it is

	const midToBodyXDistance = walrusMidBodyPosition.x - walrusBodyPosition.x
	const midToBodyYDistance = walrusMidBodyPosition.y - walrusBodyPosition.y
	if (midToBodyXDistance > maxDistance) {
		walrusMidBodyPosition.x = walrusBodyPosition.x + maxDistance
	} else if (midToBodyXDistance < -maxDistance) {
		walrusMidBodyPosition.x = walrusBodyPosition.x - maxDistance
	}
	if (midToBodyYDistance > maxDistance) {
		walrusMidBodyPosition.y = walrusBodyPosition.y + maxDistance
	} else if (midToBodyYDistance < -maxDistance) {
		walrusMidBodyPosition.y = walrusBodyPosition.y - maxDistance
	}

	const walrusTailPosition = new Point(historicPositions[20] - 70, historicPositions[21])

	// check if the walrusTail is too far away from mid body and move it closer if it is
	const tailToMidXDistance = walrusTailPosition.x - walrusMidBodyPosition.x
	const tailToMidYDistance = walrusTailPosition.y - walrusMidBodyPosition.y
	if (tailToMidXDistance > maxDistance) {
		walrusTailPosition.x = walrusMidBodyPosition.x + maxDistance
	} else if (tailToMidXDistance < -maxDistance) {
		walrusTailPosition.x = walrusMidBodyPosition.x - maxDistance
	}
	if (tailToMidYDistance > maxDistance) {
		walrusTailPosition.y = walrusMidBodyPosition.y + maxDistance
	} else if (tailToMidYDistance < -maxDistance) {
		walrusTailPosition.y = walrusMidBodyPosition.y - maxDistance
	}
	spritePool.walrusMidBody.position.copyFrom(walrusMidBodyPosition)
	spritePool.walrusTail.position.copyFrom(walrusTailPosition)

	// rotate the walrusMidBody and tail

	const midBodyAngle =
		Math.atan2(spritePool.walrusMainBody.x - spritePool.walrusMidBody.x, spritePool.walrusMainBody.y - spritePool.walrusMidBody.y) * 0.7

	const tailBodyAngle = Math.atan2(
		spritePool.walrusMidBody.x - spritePool.walrusTail.x,
		spritePool.walrusMidBody.y - spritePool.walrusTail.y,
	)

	spritePool.walrusMidBody.rotation = -(midBodyAngle + tailBodyAngle) * 0.5 + Math.PI / 2
	spritePool.walrusTail.rotation = -tailBodyAngle + Math.PI / 2
}
